import React from 'react';

const POSITIONS = ['Pies', 'Hoagies', 'Front', 'DR'];
const EXP_LEVELS = [1, 2, 3, 4, 5];

const PositionSelector = ({ positions, setPositions }) => {

    const isChecked = (positionName) =>
        positions.some(p => p.position === positionName);

    const getExperience = (positionName) => {
        const found = positions.find(p => p.position === positionName);
        return found ? found.experience : 1;
    };

    const handleCheck = (positionName, checked) => {
        if (checked) {
            setPositions(prev => [...prev, { position: positionName, experience: 1 }]);
        } else {
            setPositions(prev => prev.filter(p => p.position !== positionName));
        }
    };

    const handleExperienceChange = (positionName, expValue) => {
        setPositions(prev =>
            prev.map(p =>
                p.position === positionName
                    ? { ...p, experience: Number(expValue) }
                    : p
            )
        );
    };

    return (
        <div className="position-selector">
            <span className="position-selector-label">Positions</span>
            <div className="position-rows">
                {POSITIONS.map(pos => (
                    <div key={pos} className="position-item">
                        <label className="position-checkbox-label">
                            <input
                                type="checkbox"
                                checked={isChecked(pos)}
                                onChange={(e) => handleCheck(pos, e.target.checked)}
                            />
                            {pos}
                        </label>
                        <div className="position-exp-slot">
                            {isChecked(pos) && (
                                <>
                                    <span className="position-exp-label">Exp</span>
                                    <select
                                        value={getExperience(pos)}
                                        onChange={(e) => handleExperienceChange(pos, e.target.value)}
                                    >
                                        {EXP_LEVELS.map(level => (
                                            <option key={level} value={level}>{level}</option>
                                        ))}
                                    </select>
                                </>
                            )}
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default PositionSelector;